import axios from 'axios';
import { siteTierConfig } from '../App/App.config';
import log from 'loglevel';

const sessionMgr = async ({ type, requestId, oxygenId, Authorization }) => {
  log.log('Inside Session lambda', type, requestId, oxygenId, Authorization);
  // Initilize payload and header
  let payload = { type };
  let headers = { 'Content-Type': 'application/json' };

  // Modify payload and header according to request type
  switch (type) {
    case 'generateSignature':
      payload = { ...payload };
      if (requestId !== null) headers = { ...headers };
      break;
    case 'signIn':
      payload = { ...payload, oxygenId };
      headers = { ...headers, Session: requestId, Authorization };
      break;
    case 'validateSignIn':
      payload = { ...payload, oxygenId };
      headers = { ...headers, Session: requestId, Authorization };
      break;
    case 'signOut':
      headers = { ...headers, Session: requestId };
      break;
    default:
      log.warn('Invalid type specified for ETE session lambda');
  }

  // Call api
  try {
    log.log('Calling session lambda');
    const res = await axios.post(siteTierConfig.sessionLambdaUrl, payload, {
      headers,
    });
    log.log('Session lambda response>>>>>', res.data.data);
    return res.data.data;
  } catch (err) {
    log.error(err);
    throw err;
  }
};

export default sessionMgr;
